import "./footer.css";

import React from "react";

import { FOOTER } from "../../data/content";

const Footer = () => {
  return (
    <footer className={"site-footer"}>
      <p>
        © {new Date().getFullYear()} {FOOTER.CREDIT}
      </p>
    </footer>
  );
};

export default Footer;
